export default {
  'stockCorrections.domain.company': 'Empresa',
  'stockCorrections.domain.employee': 'Funcionário',
  'stockCorrections.domain.date': 'Data',
  'stockCorrections.domain.observation': 'Observação',
  'stockCorrections.domain.items': 'Itens',
  'stockCorrections.domain.items.itemName': 'Nome',
  'stockCorrections.domain.items.type': 'Tipo',
  'stockCorrections.domain.items.type.item_type.part': 'Peça',
  'stockCorrections.domain.items.type.item_type.consumable': 'Insumo',
  'stockCorrections.domain.items.availableStock': 'Disponível',
  'stockCorrections.domain.items.reserved': 'Reservado',
  'stockCorrections.domain.items.stock': 'Estoque',
  'stockCorrections.domain.items.originalCode': 'Cód. Interno',
  'stockCorrections.domain.items.oldQuantity': 'Qtd. Anterior',
  'stockCorrections.domain.items.newQuantity': 'Nova Qtd.',
  'stockCorrections.domain.items.deltaQuantity': 'Diferença',

  'stockCorrections.domain.items.add': 'Adicionar Item',
  'stockCorrections.domain.items.add.emptyCompanyError': 'Erro',
  'stockCorrections.domain.items.add.emptyCompanyErrorDescription':
    'Favor selecionar uma empresa antes de adicionar os itens.',

  'stockCorrections.create': 'Criar Correção de Estoque',
  'stockCorrections.create.alert': 'Atenção',
  'stockCorrections.create.alert.description':
    'Você realmente deseja enviar esta correção de estoque? Esta ação é irreversível',
  'stockCorrections.create.notification.success': 'Sucesso',
  'stockCorrections.create.notification.successDescription':
    'Correção de Estoque criado.',
  'stockCorrections.create.errors.atLeastOneItem':
    'Deve haver ao menos 1 item na correção de estoque.',

  'stockCorrections.create.items.search': 'Busque os Itens',
  'stockCorrections.create.items.searchMessage':
    'Filtre e selecione os itens a serem adicionados na correção de estoque.',

  'stockCorrections.create.items.searchConfirm': 'Confirme',
  'stockCorrections.create.items.searchConfirmMessage':
    'Cheque os items a serem adicionados e confirme.',

  'stockCorrections.details': 'Detalhes da Correção de Estoque',

  'stockCorrections.update': 'Editar Correção de Estoque',
  'stockCorrections.update.notification.success': 'Sucesso',
  'stockCorrections.update.notification.successDescription':
    'Correção de Estoque editado.',

  'stockCorrections.remove': 'Remover Correção de Estoque',
  'stockCorrections.remove.alert':
    'Você realmente deseja remover a correção de estoque:',
  'stockCorrections.remove.notification.success': 'Sucesso',
  'stockCorrections.remove.notification.successDescription':
    'Correção de Estoque removido.',
};
